import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1402294c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style1 from "./detail.vue?vue&type=style&index=1&id=1402294c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1402294c",
  null
  
)

export default component.exports